/**
 * This file was auto-generated by Fern from our API Definition.
 */
import * as core from "../../../../core";
import { AccountId } from "../../commons/types/AccountId";
export const BillingPlanWithUsage = core.serialization.object({
    accountId: AccountId,
    plan: core.serialization.string(),
    pdvs: core.serialization.number(),
    files: core.serialization.number(),
    fromDate: core.serialization.date(),
    toDate: core.serialization.date(),
    freeFileLimit: core.serialization.number(),
    freePdvLimit: core.serialization.number(),
});
